import { ActionTypes as types } from 'constants';

export default () => dispatch => {
  dispatch({
    type: types.RESET_FIND_ADDRESSES,
  });
};
